import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NovoElementsModule, NovoElementProviders, FieldInteractionApi, FormUtils, NovoLabelService, NovoModalService, NovoToastService,  } from 'novo-elements';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from 'src/environments/environment';
import { AppBridgeService } from './services/appBridge.service';
import { HttpService } from './services/http.service';
import { MetaService } from './services/meta.service';
import { QueueModal } from './components/queue-modal.component';
import { InitComponent } from './init.component';
import { AddTargetComponent } from './components/add-target/add-target.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppBridgeTargetService } from './services/appBridgeTarget.service';
import { HttpTargetService } from './services/httpTarget.service';
import { HttpService as HttpSubmissionCardService } from './services/httpSubmissionsCard.service';
import { HttpService as HttpNoteCardService } from './services/httpNoteCard.service';
import { SubmissionsCard } from './components/submissions-card/submissions-card.component';
import { SubmissionCardBridgeService } from './services/submissionCardBridge.service';
import { SubmissionCardMetaService } from './services/submissionCardMeta.service';
import { NoteCard } from './components/note-card/note-card.component';
import { NoteCardBridgeService } from './services/noteCardBridge.service';
import { NoteCardMetaService } from './services/noteCardMeta.service';
import { CommonModule } from '@angular/common';
import { DemoPageComponent } from './components/demo-page/add-target.component';
import { DemoPage2Component } from './components/demo-page-two/demo-page2.component';
import { MspCompanyComponent } from './components/msp-company/msp-company.component';
import { AppBridgeMspService } from './services/appBridgeMsp.service';
import { HttpMspService } from './services/httpMsp.service';

export function provideFieldInteractionAPI(toast, modal, formUtils, http, labels) {
  const fieldInteractionApi = new FieldInteractionApi(toast, modal, formUtils, http, labels);
  fieldInteractionApi.globals = {
    TEST: 'I AM A GLOBAL!',
  };
  return fieldInteractionApi;
}

const routes: Routes = [
  { path: 'note-card', component: NoteCard},
  { path: 'submissions-card', component: SubmissionsCard},
  { path: 'add-target', component: AddTargetComponent},
  { path: 'demo-page', component: DemoPageComponent},
  { path: 'demo-page2', component: DemoPage2Component},
  { path: 'msp-company', component: MspCompanyComponent},
  { path: '', component: AppComponent},
];


@NgModule({
  declarations: [
    InitComponent,
    AppComponent,
    QueueModal,
    AddTargetComponent,
    DemoPageComponent,
    DemoPage2Component,
    SubmissionsCard,
    NoteCard,
    MspCompanyComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    NovoElementsModule,
    NovoElementProviders.forRoot(),
    FormsModule,
    HttpClientModule,
    RouterModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  providers: [
    HttpSubmissionCardService,
    NovoLabelService,
    {
      provide: FieldInteractionApi,
      useFactory: provideFieldInteractionAPI,
      deps: [NovoToastService, NovoModalService, FormUtils, HttpClient, NovoLabelService],
    },
    AppBridgeService,
    AppBridgeTargetService,
    SubmissionCardBridgeService,
    NoteCardBridgeService,
    HttpService,
    HttpTargetService,
    HttpNoteCardService,
    MetaService,
    SubmissionCardMetaService,
    NoteCardMetaService,
    AppBridgeMspService,
    HttpMspService,
  ],
  bootstrap: [InitComponent]
}) 
export class AppModule { }
